import {Icon, Image} from '@wandb/components';
import React from 'react';

interface ImageThumbnailProps {
  /** Image source; a `data:` URL or any valid img src. */
  src: string;
  alt?: string;
  /**
   * When provided, renders a round remove button overhanging the top-right
   * corner. Omit for read-only thumbnails.
   */
  onRemove?: () => void;
  removeLabel?: string;
  /**
   * When set, dims the image and overlays this message (e.g. "Upload failed")
   * to mark the attachment as broken.
   */
  error?: string;
}

const RemoveButton = ({
  onRemove,
  description = 'Remove image',
}: {
  onRemove: () => void;
  description?: string;
}) => (
  <button
    type="button"
    aria-label={description}
    onClick={onRemove}
    className="absolute -right-[4px] -top-[4px] z-10 flex h-[20px] w-[20px] items-center justify-center rounded-full border border-moon-250 bg-[#0D0F12] text-white transition-colors hover:cursor-pointer">
    <Icon icon="close" size="xs" color="currentcolor" />
  </button>
);

export const ImageThumbnail = ({
  src,
  alt = 'attachment',
  onRemove,
  removeLabel,
  error,
}: ImageThumbnailProps) => (
  <div className="relative shrink-0">
    <div className="relative flex h-[120px] w-[120px] flex-col flex-start overflow-hidden rounded-lg border border-moon-250 shadow-flat">
      <Image alt={alt} objectFit="cover" src={src} />
      {error && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-white/70 px-8 text-center text-sm text-red-600">
          <Icon icon="warning" />
          {error}
        </div>
      )}
    </div>
    {onRemove && <RemoveButton onRemove={onRemove} description={removeLabel} />}
  </div>
);
